import { render, staticRenderFns } from "./PosReportFilter.vue?vue&type=template&id=38fba75d&"
import script from "./PosReportFilter.vue?vue&type=script&lang=js&"
export * from "./PosReportFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports